import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Heittotekniikat — Frisbeegolf' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Frisbeegolf"
			title="Heittotekniikat"
			intro="Backhand, forehand ja erilaiset otteet, joilla pääset alkuun ja kehityt."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
